import {
    EXPERTISES_FETCHING,
    EXPERTISES_FAILED,
    EXPERTISES_SUCCESS
} from "../actions/types";

const initialState = {
    result: null,
    isFetching: false,
    isError: false
}

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case EXPERTISES_FETCHING:
            return {...state, result: null, isFetching: true, isError: false};
        case EXPERTISES_FAILED:
            return {...state, result: null, isFetching: false, isError: true};
        case EXPERTISES_SUCCESS:
            return {...state, result: payload, isFetching: false, isError: false};
        default:
            return state;
    }
};